const extractNumberAndText = (text) => {
    const match = text.match(/([\d,\s.]+)(\s?.*)/);

    if (match) {
        let numberString = match[1].trim();
        const commaCount = (numberString.match(/,/g) || []).length;
        
        if (commaCount === 1) {
            const parts = numberString.split(',');
            if (parts[1] && parts[1].length <= 3 && /^\d+$/.test(parts[1])) {
                numberString = numberString.replace(',', '.');
            } else {
                numberString = numberString.replace(/[,\s]/g, '');
            }
        } else {
            numberString = numberString.replace(/[,\s]/g, '');
        }

        const parsedNumber = parseFloat(numberString);

        return {
            number: isNaN(parsedNumber) ? null : parsedNumber,
            suffix: match[2] || ""
        };
    }
    return { number: null, suffix: text };
};

const startCounting = (bigNumber) => {
    const textContent = bigNumber.innerText.trim();
    const { number, suffix } = extractNumberAndText(textContent);

    if (number !== null) {
        let currentCount = 0;
        const interval = number < 1000 ? 100 : (number < 10000 ? 50 : 25);
        const increment = number / (2000 / interval);

      
        const updateCount = () => {
            if (currentCount < number) {
                currentCount += increment;
                const formattedNumber = Number.isInteger(number) ?
                    Math.floor(currentCount).toLocaleString("nb-NO") :
                    currentCount.toLocaleString("nb-NO", { minimumFractionDigits: 1, maximumFractionDigits: 2 });
                bigNumber.innerText = formattedNumber + suffix;
                setTimeout(updateCount, interval);
            } else {
                const finalFormatted = Number.isInteger(number) ?
                    number.toLocaleString("nb-NO") :
                    number.toLocaleString("nb-NO", { minimumFractionDigits: 1, maximumFractionDigits: 2 });
                bigNumber.innerText = finalFormatted + suffix;
            }
        };

        updateCount();
    }
}

const handleFadeInElement = (element) => {
    const windowHeight = window.innerHeight;
    const elementTop = element.getBoundingClientRect().top;
    const elementHeight = element.getBoundingClientRect().height;
    let elementVisible = 128;

    if (element.classList.contains('delay-transition')) {
        elementVisible = elementHeight;
    }

    if (elementTop < windowHeight - elementVisible) {
        element.classList.add("active");
        element.classList.remove("inactive");

        if (!element.hasAttribute('data-counting-started')) {
            // Finn tallet i big-number og start telling
            const bigNumber = element.querySelector('.big-number');
            if (bigNumber) {
                startCounting(bigNumber);
            }
            element.setAttribute('data-counting-started', 'true');
        }
    } else {
        element.classList.add("inactive");
        element.classList.remove("active");
        element.removeAttribute('data-counting-started');
    }
}

const handleScroll = () => {
    const slideInElements = document.querySelectorAll(".fade-in");

    for (let i = 0; i < slideInElements.length; i++) {
        handleFadeInElement(slideInElements[i]);
    }
}

window.addEventListener("scroll", handleScroll);

window.scrollToTop = () => {
    window.scrollTo(0, 0);
}

window.scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        window.testElement = element;
        const topOffset = 128;
        const elementPosition = element.getBoundingClientRect().top;

        window.scrollBy({
            top: elementPosition - topOffset,
            behavior: "smooth"
        });
    }
}